import { __decorate, __metadata } from "tslib";
import { IsNotEmptyObjectWithLVS } from '@goparrot/common';
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsOptional, IsString, MaxLength } from 'class-validator';
import { WebMerchantExposeGroup } from '../interface';
export class ReadWebMerchantInfoBannerDto {
}
__decorate([
    ApiPropertyOptional({ type: () => Object, description: 'Styles for text' }),
    IsNotEmptyObjectWithLVS({ always: true }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebMerchantInfoBannerDto.prototype, "message", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object, description: 'Styles for container' }),
    IsNotEmptyObjectWithLVS({ always: true }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebMerchantInfoBannerDto.prototype, "container", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Icon color' }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsString({ always: true }),
    MaxLength(100, { always: true }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebMerchantInfoBannerDto.prototype, "iconColor", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Close button icon color' }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsString({ always: true }),
    MaxLength(100, { always: true }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebMerchantInfoBannerDto.prototype, "closeButtonColor", void 0);
//# sourceMappingURL=ReadWebMerchantInfoBannerDto.js.map